var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 2.5a.5.5 0 0 1 .5.5v6.475l1.628-1.81a.5.5 0 1 1 .744.67l-2.5 2.777a.5.5 0 0 1-.744 0l-2.5-2.778a.5.5 0 1 1 .744-.668L7.5 9.475V3a.5.5 0 0 1 .5-.5M4.5 13a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
export { SvgDownload as ReactComponent };
export default __webpack_public_path__ + "64ab697ca1e45bcc8acd7c1fb0ddfefe.svg";